import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function NotFound() {
  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center px-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center"
      >
        <h1 className="text-8xl font-morganite text-brand-red mb-4">404</h1>
        <p className="text-2xl font-morganite text-brand-peach mb-8">
          Página no encontrada
        </p>
        <Link 
          to="/" 
          className="inline-block px-8 py-3 bg-brand-red text-brand-white 
                   font-helvetica rounded-lg hover:opacity-90 transition-opacity duration-300"
        >
          Volver al inicio
        </Link>
      </motion.div>
    </div>
  );
}

export default NotFound;